/*
 * Workshop UI only: merch tabs, gallery selection, video play, countdown anti-flash,
 * and the product-page entry tag hooks (quantity, variant price, mobile dock).
 * Giveaway Gator’s app embed owns gg-timers.js and GiveawayGatorTimers.
 * This file does not calculate entries or store an end time.
 */
(function () {
  var TIMER_LABELS = { d: "Days", h: "Hrs", m: "Min", s: "Sec" };

  function paintTimer(el) {
    var raw = (el.textContent || "").replace(/\s+/g, " ").trim();
    var face = el.nextElementSibling;
    var hasFace = face && face.hasAttribute("data-gw-timer-face");
    var pending = raw.indexOf("${") !== -1 || raw === "";

    if (!hasFace) {
      el.hidden = pending;
      return;
    }

    if (pending) {
      el.hidden = true;
      face.hidden = true;
      return;
    }

    if (face.getAttribute("data-gw-last") === raw) {
      el.hidden = true;
      face.hidden = false;
      return;
    }

    var matches = raw.match(/\d+\s*[dhms]/gi) || [];
    face.replaceChildren();

    if (!matches.length) {
      face.textContent = raw;
    } else {
      matches.forEach(function (token, index) {
        var parts = token.match(/(\d+)\s*([dhms])/i);
        if (!parts) return;
        if (index > 0) {
          var sep = document.createElement("span");
          sep.className = "gw-timer__sep";
          sep.setAttribute("aria-hidden", "true");
          sep.textContent = ":";
          face.appendChild(sep);
        }
        var unit = document.createElement("span");
        unit.className = "gw-timer__unit";
        var num = document.createElement("span");
        num.className = "gw-timer__num";
        num.textContent = parts[1];
        var label = document.createElement("span");
        label.className = "gw-timer__label";
        label.textContent = TIMER_LABELS[parts[2].toLowerCase()] || parts[2];
        unit.append(num, label);
        face.appendChild(unit);
      });
    }

    face.setAttribute("data-gw-last", raw);
    face.setAttribute("aria-label", raw);
    el.hidden = true;
    face.hidden = false;
  }

  function maskTimers(root) {
    root.querySelectorAll("[data-gg-countdown-timer]").forEach(paintTimer);
  }

  function watchTimers(root) {
    if (!root.querySelector("[data-gg-countdown-timer]")) return;
    maskTimers(root);
    if (root.dataset.ggWatch === "true") return;
    root.dataset.ggWatch = "true";
    var observer = new MutationObserver(function () {
      maskTimers(root);
    });
    observer.observe(root, { subtree: true, characterData: true, childList: true });
  }

  function initMerch(root) {
    var tabs = root.querySelectorAll("[data-merch-tab]");
    if (!tabs.length || root.dataset.merchBound === "true") return;
    root.dataset.merchBound = "true";
    var panels = root.querySelectorAll("[data-merch-panel]");
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var id = tab.getAttribute("data-merch-tab");
        tabs.forEach(function (item) {
          var on = item === tab;
          item.setAttribute("aria-selected", on ? "true" : "false");
          item.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute("data-merch-panel") !== id;
        });
      });
    });
  }

  function initGallery(root) {
    var stage = root.querySelector("[data-gallery-media]");
    if (!stage || root.dataset.galleryBound === "true") return;
    root.dataset.galleryBound = "true";
    var thumbs = root.querySelectorAll("[data-gallery-thumb]");
    var caption = root.querySelector("[data-gallery-caption]");
    var counter = root.querySelector("[data-gallery-counter]");

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener("click", function () {
        var image = thumb.querySelector("img");
        var slot = thumb.querySelector(".giveaway-asset-slot");
        stage.replaceChildren();
        if (image) {
          stage.appendChild(image.cloneNode(true));
        } else if (slot) {
          stage.appendChild(slot.cloneNode(true));
        }
        if (caption) caption.textContent = thumb.getAttribute("data-caption") || "";
        if (counter) {
          var position = Number(thumb.getAttribute("data-index") || index + 1);
          var totalCount = Number(root.getAttribute("data-gallery-total") || thumbs.length);
          var current = String(position).padStart(2, "0");
          var total = String(totalCount).padStart(2, "0");
          counter.textContent = current + " / " + total;
        }
        thumbs.forEach(function (item) {
          item.setAttribute("aria-current", item === thumb ? "true" : "false");
        });
      });
    });

    // "+N more" tile: first click shows its own photo, then each click steps through the hidden extras and wraps.
    var more = root.querySelector("[data-gallery-more]");
    var extras = root.querySelectorAll("[data-gallery-extra]");
    if (more && extras.length) {
      var cycle = [more].concat(Array.prototype.slice.call(extras));
      var step = 0;
      more.addEventListener("click", function (event) {
        if (!more.dataset.galleryCycling) {
          more.dataset.galleryCycling = "true";
          return;
        }
        event.stopImmediatePropagation();
        step = (step + 1) % cycle.length;
        var target = cycle[step];
        if (target === more) {
          delete more.dataset.galleryCycling;
          step = 0;
          more.click();
          return;
        }
        target.click();
        more.setAttribute("aria-current", "true");
      }, true);
    }
  }

  function initVideo(root) {
    var button = root.querySelector("[data-giveaway-video-play]");
    if (!button || root.dataset.videoBound === "true") return;
    root.dataset.videoBound = "true";
    button.addEventListener("click", function () {
      var stage = root.querySelector("[data-giveaway-video-stage]");
      var id = root.getAttribute("data-youtube-id");
      if (!stage || !id) return;
      var iframe = document.createElement("iframe");
      iframe.className = "giveaway-video__iframe";
      iframe.src = "https://www.youtube.com/embed/" + encodeURIComponent(id) + "?autoplay=1&rel=0";
      iframe.title = root.getAttribute("data-video-title") || "Video";
      iframe.allow = "autoplay; encrypted-media; picture-in-picture";
      iframe.allowFullscreen = true;
      stage.replaceChildren(iframe);
    });
  }

  function init(root) {
    if (!root) return;
    initMerch(root);
    initGallery(root);
    initVideo(root);
    watchTimers(root);
  }

  function bindEnterNowAutohide() {
    var header = document.getElementById("header-component");
    if (!header || !header.hasAttribute("data-enter-now-autohide") || header.dataset.enterNowBound === "true") return;
    header.dataset.enterNowBound = "true";

    var wrapper = document.querySelector(".page-wrapper");
    var frame = 0;

    var narrow = window.matchMedia("(max-width: 749px)");

    var lastTop = 0;

    function scrolled() {
      var top = window.scrollY;
      if (wrapper) top = Math.max(top, wrapper.scrollTop);
      var hidden = false;
      if (narrow.matches && top > 12) {
        if (top > lastTop + 2) hidden = true;
        else if (top < lastTop - 2) hidden = false;
        else hidden = header.classList.contains("is-enter-now-hidden");
      }
      header.classList.toggle("is-enter-now-hidden", hidden);
      lastTop = top;
    }

    function onScroll() {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        scrolled();
      });
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    if (wrapper) wrapper.addEventListener("scroll", onScroll, { passive: true });
    narrow.addEventListener("change", scrolled);
    scrolled();
  }

  function entriesApiUrl() {
    var shop = (window.Shopify && window.Shopify.shop) || "";
    var devShops = [
      "giveaway-gator.myshopify.com",
      "gg-plus-2.myshopify.com",
      "checkout-test-giveaway-gator.myshopify.com",
    ];
    var appPath = devShops.indexOf(shop) !== -1 ? "giveaway-gator-dev-remix" : "giveaway-gator";
    return "/apps/" + appPath + "/api/entries/calculate";
  }

  function paintCartEntries(total) {
    document.querySelectorAll("[data-gg-cart-entries-row]").forEach(function (row) {
      var value = row.querySelector("[data-gg-cart-entries]");
      if (value) value.textContent = String(total);
      row.hidden = total <= 0;
    });
  }

  function promotionTotal(result) {
    return (result.promotions || [])
      .filter(function (promo) {
        return promo && promo.totalEntries > 0;
      })
      .reduce(function (sum, promo) {
        return sum + promo.totalEntries;
      }, 0);
  }

  function unitDollars(item) {
    var cents = item.final_price != null ? item.final_price : item.price || 0;
    return cents / 100;
  }

  function lineDollars(item) {
    if (item.final_line_price != null) return item.final_line_price / 100;
    return unitDollars(item) * (item.quantity || 1);
  }

  function calculationBody(shop, items, discountCodes) {
    return {
      shop: shop,
      totalPrice: items.reduce(function (sum, item) {
        return sum + lineDollars(item);
      }, 0),
      discountCodes: discountCodes,
      lineItems: items.map(function (item) {
        return {
          productId: String(item.product_id),
          variantId: String(item.variant_id),
          quantity: item.quantity || 0,
          price: unitDollars(item),
          title: item.product_title || item.title || "",
        };
      }),
    };
  }

  var lastLineTotals = [];

  function paintLineEntries() {
    lastLineTotals.forEach(function (row) {
      document
        .querySelectorAll('.cart-items__details [data-gg-entry-tag][data-product-id="' + row.productId + '"]')
        .forEach(function (tag) {
          var totalEl = tag.querySelector(".gg-entry-total");
          var labelEl = tag.querySelector(".gg-entry-label");
          if (totalEl) totalEl.textContent = String(row.total);
          if (labelEl) labelEl.textContent = "entries";
          tag.style.display = "inline-flex";
        });
    });
  }

  var cartEntriesRequest = 0;

  function fillCartEntries() {
    if (!document.querySelector("[data-gg-cart-entries-row]")) return;
    var requestId = ++cartEntriesRequest;
    var shop = (window.Shopify && window.Shopify.shop) || "";
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Cart request failed");
        return response.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        if (!items.length) {
          if (requestId === cartEntriesRequest) paintCartEntries(0);
          return null;
        }
        var discountCodes = (cart.discount_codes || [])
          .filter(function (entry) {
            return entry && entry.code && entry.applicable !== false;
          })
          .map(function (entry) {
            return entry.code;
          });
        var posts = [calculationBody(shop, items, discountCodes)].concat(
          items.map(function (item) {
            return calculationBody(shop, [item], discountCodes);
          })
        );
        return Promise.all(
          posts.map(function (body) {
            return fetch(entriesApiUrl(), {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              credentials: "same-origin",
              body: JSON.stringify(body),
            }).then(function (response) {
              if (!response.ok) throw new Error("Entry calculation failed");
              return response.json();
            });
          })
        ).then(function (results) {
          return { items: items, results: results };
        });
      })
      .then(function (payload) {
        if (requestId !== cartEntriesRequest || !payload) return;
        paintCartEntries(promotionTotal(payload.results[0]));
        lastLineTotals = payload.items.map(function (item, index) {
          return {
            productId: String(item.product_id),
            total: promotionTotal(payload.results[index + 1]),
          };
        });
        paintLineEntries();
      })
      .catch(function () {
        if (requestId === cartEntriesRequest) paintCartEntries(0);
      });
  }

  function productSurfaces(root) {
    if (!root || !root.querySelectorAll) return [];
    if (root.matches && root.matches(".product-information")) return [root];
    return Array.prototype.slice.call(root.querySelectorAll(".product-information"));
  }

  function setEntryQty(section, qty) {
    var value = parseInt(qty, 10);
    if (!value || value < 1) value = 1;
    section.querySelectorAll("[data-gg-entry-tag]").forEach(function (tag) {
      tag.setAttribute("data-gg-qty", String(value));
    });
  }

  function priceCents(result) {
    var resource = result && result.detail && result.detail.resource;
    if (resource && typeof resource.price === "number") return resource.price;
    var amount = result && result.variant && result.variant.price && result.variant.price.amount;
    var parsed = Number(amount);
    if (!isFinite(parsed)) return null;
    return Math.round(parsed * 100);
  }

  function applyVariantPrice(section, result) {
    var cents = priceCents(result);
    if (cents != null) {
      section.querySelectorAll("[data-gg-entry-tag]").forEach(function (tag) {
        tag.setAttribute("data-price", String(cents / 100));
      });
    }

    var html = result && result.detail && result.detail.html;
    var priceEl = section.querySelector("[data-gg-dock-price]");
    var source = html && html.querySelector && html.querySelector('product-price [ref="priceContainer"]');
    if (priceEl && source) {
      var text = (source.textContent || "").replace(/\s+/g, " ").trim();
      if (text) priceEl.textContent = text;
    }

    var dockButton = section.querySelector("[data-gg-pdp-dock-submit]");
    var nextButton = html && html.querySelector && html.querySelector('[ref="addToCartButton"]');
    if (dockButton && nextButton) {
      dockButton.disabled = nextButton.hasAttribute("disabled");
      var label = (nextButton.textContent || "").replace(/\s+/g, " ").trim();
      if (label) dockButton.textContent = label;
    }
  }

  function bindProductDock(section) {
    var dock = section.querySelector("[data-gg-pdp-dock]");
    if (!dock || dock.dataset.ggDockBound === "true") return;
    dock.dataset.ggDockBound = "true";

    var qtyInput = section.querySelector('input[name="quantity"]');
    if (qtyInput) setEntryQty(section, qtyInput.value);

    var target = section.querySelector(".product-form-buttons") || section.querySelector('[ref="addToCartButton"]');
    var mq = window.matchMedia("(max-width: 749px)");

    function syncDockVisibility(entry) {
      if (!mq.matches || !entry) {
        dock.classList.remove("is-visible");
        dock.setAttribute("aria-hidden", "true");
        return;
      }
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      dock.classList.toggle("is-visible", scrolledPast);
      dock.setAttribute("aria-hidden", scrolledPast ? "false" : "true");
    }

    if (target && "IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function (entries) {
        syncDockVisibility(entries[0]);
      }, { threshold: 0 });
      observer.observe(target);
      if (mq.addEventListener) {
        mq.addEventListener("change", function () {
          if (!mq.matches) syncDockVisibility(null);
        });
      }
    }

    var submit = dock.querySelector("[data-gg-pdp-dock-submit]");
    if (submit) {
      submit.addEventListener("click", function () {
        var button = section.querySelector('product-form-component [ref="addToCartButton"]');
        if (!button || button.disabled) return;
        button.click();
      });
    }
  }

  function bindProductEntries(root) {
    productSurfaces(root).forEach(bindProductDock);
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-giveaway-workshop]").forEach(init);
    watchTimers(document.documentElement);
    bindEnterNowAutohide();
    fillCartEntries();
    bindProductEntries(root);
  }

  if (!window.__giveawayWorkshopListeners) {
    window.__giveawayWorkshopListeners = true;
    document.addEventListener("shopify:section:load", function (event) {
      var sectionRoot = event.target;
      if (!sectionRoot || !sectionRoot.querySelectorAll) return;

      if (sectionRoot.querySelector("[data-gg-countdown-timer]")) {
        sectionRoot.querySelectorAll("[data-gg-initialized]").forEach(function (el) {
          el.removeAttribute("data-gg-initialized");
        });
        sectionRoot.removeAttribute("data-gg-initialized");
        if (window.GiveawayGatorTimers && typeof window.GiveawayGatorTimers.initialize === "function") {
          window.GiveawayGatorTimers.initialize(sectionRoot);
        }
      }

      sectionRoot.querySelectorAll("[data-giveaway-workshop]").forEach(function (el) {
        delete el.dataset.merchBound;
        delete el.dataset.galleryBound;
        delete el.dataset.videoBound;
        delete el.dataset.ggWatch;
      });
      sectionRoot.querySelectorAll("[data-gg-pdp-dock]").forEach(function (el) {
        delete el.dataset.ggDockBound;
      });
      boot(sectionRoot);
    });
    document.addEventListener("quantity-selector:update", function (event) {
      if (!event.detail || event.detail.cartLine) return;
      var section = event.target && event.target.closest && event.target.closest(".product-information");
      if (!section || !section.querySelector("[data-gg-entry-tag]")) return;
      setEntryQty(section, event.detail.quantity);
    });
    document.addEventListener("shopify:product:select", function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest("product-card")) return;
      var section = target.closest(".product-information");
      if (!section || !section.querySelector("[data-gg-entry-tag]")) return;
      if (!event.promise || typeof event.promise.then !== "function") return;
      event.promise.then(
        function (result) {
          applyVariantPrice(section, result);
        },
        function () {}
      );
    });
    document.addEventListener("giveawayGatorReady", function () {
      setTimeout(paintLineEntries, 0);
    });
    document.addEventListener("shopify:cart:lines-update", function (event) {
      var refresh = function () {
        fillCartEntries();
      };
      if (event.promise && typeof event.promise.then === "function") {
        event.promise.then(refresh, refresh);
      } else {
        refresh();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }
})();
